import { FormContext, Controller, useForm } from "react-hook-form";
import React, { useEffect, useState, Suspense } from "react";
import useStyles from "../../../../themes/makeStyles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import { Box, Typography } from "@material-ui/core";
import Tatreport from "./Reports/TatReport";
import RevenueReport from "./Reports/RevenueReport";

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function ReportTabs() {
  const classes = useStyles();
  const methods = useForm();
  const {
    register,
    control,
    errors,
    handleSubmit,
    setValue,
    reset,
    getValues,
    validateform,
    triggerValidation,
  } = methods;
  const [values, setValues] = React.useState(0);
  const [TabName, setTabName] = useState([
    {
      Name: "TAT Reconciliation Report",
      Component: Tatreport,
    },
    {
      Name: "Revenue Report",
      Component: RevenueReport,
    },
  ]);

  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      "aria-controls": `scrollable-auto-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValues(newValue);
  };

  return (
    <div>
      <Box pb={1}>
        <Typography className={classes.secondHeading}> </Typography>
      </Box>
      <Box>
        <Box className="tabsBgSa">
          <Tabs
            value={values}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            // className="stickyTabs"
          >
            {TabName &&
              TabName.length > 0 &&
              TabName.map((row, index) => {
                return (
                  <Tab key={index} label={row.Name} {...a11yProps(index)} />
                );
              })}
          </Tabs>
        </Box>
        {TabName &&
          TabName.length > 0 &&
          TabName.map((row, index) => {
            return (
              <TabPanel
                key={index}
                value={values}
                index={index}
                label={row.Name}
                {...a11yProps(index)}
                className="tabPanelBorder"
              >
                <row.Component />
              </TabPanel>
            );
          })}
      </Box>
    </div>
  );
}
